import _ from 'lodash';
import { log } from '@swiper/core';
import { DataFilesService } from './DataFilesService';
import { generateId } from '../utils';

export class ErrorsService extends DataFilesService {

  get name() { return 'members'; }

  async create( data, params ) {
    const id = generateId( 'error' );
    return this.write( this.pathto( id ), data );
  }

}

export const hooks = {
  before  : {
    find  : [ 'auth' ],
    get   : [ 'auth' ],
  },
};
